import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  useTheme
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import QrCodeIcon from '@mui/icons-material/QrCode';
import WechatIcon from '@mui/icons-material/Chat';

const CustomerServiceModal = ({
  open,
  onClose,
  title = '联系客服',
  isFestival = false,
  qrCodeSrc = '/images/support_qrcode.png',
  festivalQrCodeSrc = '/images/support_qrcode_red.png', // 使用刚才生成的红色二维码
}) => {
  const theme = useTheme();
  const primaryColor = isFestival ? '#FF0000' : theme.palette.primary.main;

  // 根据是否为节日/分享模式调整文案
  const mainSubtitle = isFestival ? '分享小红书种草笔记，可赠送2个点数' : '扫码添加客服微信';
  const subSubtitle = isFestival ? '凭笔记链接，审核后即可获得奖励' : '专业客服为您提供一对一咨询和认证服务';
  const serviceTimeText = isFestival ? '活动不限时：全天候专业支持' : '周一至周日 9:00-21:00';
  const currentQrCode = isFestival ? festivalQrCodeSrc : qrCodeSrc;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
          overflow: 'visible', // 允许装饰物溢出到外部
          position: 'relative'
        }
      }}
    >
      <DialogTitle sx={{
        textAlign: 'center',
        pb: 1,
        position: 'relative'
      }}>
        {/* 节日装饰图片 - 紧贴顶部外部 */}
        {isFestival && (
          <Box sx={{
            position: 'absolute',
            bottom: '90%', // 底边缘紧贴父容器顶部
            left: '50%',
            transform: 'translateX(-50%)',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            pointerEvents: 'none',
            zIndex: 10,
            mb: '-2px' // 极小负边距，消除渲染可能出现的1px白缝
          }}>
            <Box
              component="img"
              src="/images/shengdan_bg.png"
              sx={{
                width: '400px', // 设置宽度为 400px
                height: 'auto',
                filter: 'drop-shadow(0 -4px 8px rgba(0,0,0,0.1))',
              }}
            />
          </Box>
        )}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: isFestival ? primaryColor : 'grey.500',
            opacity: isFestival ? 0.7 : 1,
            '&:hover': {
              color: primaryColor,
              opacity: 1
            }
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
          <Typography variant="h5" sx={{ fontWeight: 600, color: primaryColor }}>
            {title}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', py: 3 }}>
        {/* 二维码区域 */}
        <Box
          sx={{
            width: 200,
            height: 200,
            mx: 'auto',
            mb: 3,
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            p: 1,
            backgroundColor: isFestival ? 'white' : 'transparent',
            boxShadow: `0 4px 12px ${isFestival ? 'rgba(255, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
            border: isFestival ? `1px solid ${primaryColor}30` : 'none'
          }}
        >
          <img
            src={currentQrCode}
            alt="客服微信二维码"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '8px'
            }}
          />
        </Box>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: isFestival ? primaryColor : 'inherit' }}>
          {mainSubtitle}
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: isFestival ? `${primaryColor}CC` : 'text.secondary' }}>
          {subSubtitle}
        </Typography>

        {/* 服务时间 */}
        <Box sx={{
          backgroundColor: primaryColor + '10',
          borderRadius: 2,
          p: 2,
          mb: 2,
          border: isFestival ? `1px dashed ${primaryColor}40` : 'none'
        }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: primaryColor, mb: 1 }}>
            服务时间
          </Typography>
          <Typography variant="body2" sx={{ color: isFestival ? `${primaryColor}AA` : 'text.secondary' }}>
            {serviceTimeText}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CustomerServiceModal; 